<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    height="800px"
    :mask-closable="false"
    :visible="visible"
    :footer="null"
    title="查看详情"
    @cancel="$emit('onCancel')"
  >
    <iframe
      id="iframe"
      width="100%"
      height="600px"
      :src="src"
    />
    <slot />
  </a-modal>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  mounted(){
  },

};
</script>
<style lang="scss" scoped>
iframe {
  border:none;
}

</style>
